// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3nNL_","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Ol30C"};